import { FT, Scene } from 'ft'
import { Sprite } from 'pixi.js'
import { timer } from 'ft/utils'
import Dialog from '#/components/Dialog'
import Mask from '#/components/Mask'
import Underline from '#/components/Underline'
import store from '#/store'
import hooks from '#/hooks'
import urls from '#/urls'
import bgm from '#/bgm'
import track from '#/track'
import BG from './BG'
import BG1 from './BG1'
import Player from './Player'
import PlayerHand from './PlayerHand'
import Hero from './Hero'
import Quilt from './Quilt'
import SubtitlePlayer from './SubtitlePlayer'
import Thermograph from './Thermograph'
import Record from './Record'
import Draw from './Draw'
import RuleBox from './RuleBox'

const { rm } = FT

const $soundButton = 'sound.ui-ok'
const $soundBubble = 'sound.bubble'
const $bubble = 'bed-bubble'
const $bubbleFriendEnough = 'bed-bubble-friend-enough'
const $bubbleFriendNotEnough = 'bed-bubble-friend-not-enough'
const $buttonRule = 'bed-button-rule'
const $buttonViewRecord = 'bed-button-view-record'
const $buttonExplore = 'bed-button-explore'
const $buttonInvite = 'bed-button-invite'
const $buttonJoin = 'bed-button-join'
const $buttonCreate = 'bed-button-create'
const $shareTip = 'share-tip'

rm.addImage($bubble)
rm.addImage($buttonRule)
rm.addImage($buttonViewRecord)
rm.addImage($bubbleFriendEnough)
rm.addImage($bubbleFriendNotEnough)
rm.addImage($buttonExplore)
rm.addImage($buttonInvite)
rm.addImage($buttonJoin)
rm.addImage($buttonCreate)
rm.addImage($shareTip)
rm.addSound($soundButton)
rm.addSound($soundBubble)
;[1, 2, 3].forEach(i => {
  rm.addImage(`bed-quilt${i}`)
  rm.addImage(`bed-quilt${i}-empty`)
  rm.addImage(`bed-quilt${i}-slogan`)
})

class Bed extends Scene {
  constructor(name) {
    super(name)

    track(`${store.type}-scene4`, `${store.type}-场景4`)

    hooks.renderBed = this.rerender
    hooks.showShareTip = this.showShareTip

    bgm.playBedroom()

    this.render()

    switch (store.type) {
      case 'old-user':
        this.initOldUser()
        break
      case 'friend':
        this.initFriend()
        break
      case 'new-user':
      default:
        this.initNewUser()
    }
  }

  render() {
    const {
      username,
      hero: heroId,
      quilt: quiltId,
      level,
      temp,
      isRewarded,
      friends,
    } = store
    const friendsCount = friends.length

    const bg = new BG(friendsCount)
    this.bg = bg
    this.addChild(bg)

    const thermograph = new Thermograph(username, temp)
    this.thermograph = thermograph
    thermograph.position.set(
      FT.stage.bounds.left + 38,
      FT.stage.bounds.top + 58
    )
    this.addChild(thermograph)

    const hero = new Hero(heroId, temp)
    this.hero = hero
    this.addChild(hero)

    const player = new Player(temp)
    this.player = player
    this.addChild(player)

    const bg1 = new BG1(friendsCount)
    this.bg1 = bg1
    this.addChild(bg1)

    const quilt = new Quilt(isRewarded, quiltId, level)
    this.addChild(quilt)

    const playerHand = new PlayerHand()
    this.addChild(playerHand)
  }

  rerender = () => {
    const { hero: heroId, temp, friends } = store
    const friendsCount = friends.length

    this.bg.render(friendsCount)
    this.bg1.render(friendsCount)
    this.hero.render(heroId, temp)
    this.thermograph.render(temp)
    this.player.render(temp)
  }

  addSubtitlePlayer() {
    const player = new SubtitlePlayer()
    player.x = FT.stage.bounds.left
    player.y = FT.stage.centerY
    this.addChild(player)
  }

  initNewUser = async () => {
    await timer.delay(1000)
    this.showBubble()

    await timer.delay(1000)
    this.showDialog()
  }

  addButtonsForNewUser() {
    const ruleTrigger = new Underline('活动规则')
    ruleTrigger.x = FT.stage.centerX
    ruleTrigger.y = FT.stage.bounds.bottom - 90
    ruleTrigger.interactive = true
    ruleTrigger.on('pointerup', this.showRuleBox)
    this.addChild(ruleTrigger)

    const buttonExplore = new Sprite(FT.rm.texture($buttonExplore))
    buttonExplore.interactive = true
    buttonExplore.anchor.set(0.5)
    buttonExplore.x = FT.stage.centerX - 150
    buttonExplore.y = FT.stage.bounds.bottom - 160
    buttonExplore.once('pointerup', () => {
      FT.rm.sound($soundButton).play()
      window.location = urls.activity
    })
    this.addChild(buttonExplore)

    const buttonInvite = new Sprite(FT.rm.texture($buttonInvite))
    buttonInvite.interactive = true
    buttonInvite.anchor.set(0.5)
    buttonInvite.x = FT.stage.centerX + 150
    buttonInvite.y = FT.stage.bounds.bottom - 160
    buttonInvite.on('pointerup', () => {
      FT.rm.sound($soundButton).play()
      hooks.invite()
    })
    this.addChild(buttonInvite)
  }

  showBubble() {
    const bubble = new Sprite(rm.texture($bubble))
    bubble.anchor.set(0, 1)
    bubble.scale.set(0.8)
    bubble.x = 400
    bubble.y = 458
    rm.sound($soundBubble).play()
    this.addChild(bubble)
  }

  showDialog() {
    const dialog1 = new Dialog(
      '诶呀还有奖励，你太客气了！顺\n便说下我的账号是#@%*)',
      {},
      () => {
        this.removeChild(dialog1)
        this.addChild(dialog2)
      }
    )
    const dialog2 = new Dialog('不过，怎样才能获得奖励呢？', {
      align: 'center',
      next: false,
    })
    const button = new Sprite(rm.texture($buttonRule))
    button.interactive = true
    button.anchor.set(0.5, 0)
    button.y = 125
    dialog2.addChild(button)

    button.on('pointerup', () => {
      this.removeChild(dialog2)
      this.addButtonsForNewUser()
      this.showRuleBox()
    })

    this.addChild(dialog1)
  }

  showRuleBox = () => {
    if (this.ruleBox) return

    const ruleBox = new RuleBox(() => {
      ruleBox.parent.removeChild(ruleBox)
      this.ruleBox = null
    })
    this.ruleBox = ruleBox
    this.addChild(ruleBox)
  }

  initOldUser = async () => {
    if (store.isRewarded) {
      await timer.delay(1000)
      this.showBubbleForOldUser()

      await timer.delay(2000)
      const draw = new Draw()
      draw.position.set(FT.stage.centerX, FT.stage.centerY)
      this.addChild(draw)
    } else {
      this.addSubtitlePlayer()

      const { rm } = FT
      const buttonViewRecord = new Sprite(rm.texture($buttonViewRecord))
      buttonViewRecord.interactive = true
      buttonViewRecord.anchor.set(0.5)
      buttonViewRecord.x = FT.stage.centerX - 150
      buttonViewRecord.y = FT.stage.bounds.bottom - 130
      this.addChild(buttonViewRecord)

      const record = new Record(store.friends, () => {
        record.parent.removeChild(record)
      })

      buttonViewRecord.on('pointerup', () => {
        rm.sound($soundButton).play()
        this.addChild(record)
      })

      const buttonInvite = new Sprite(rm.texture($buttonInvite))
      buttonInvite.interactive = true
      buttonInvite.anchor.set(0.5)
      buttonInvite.x = FT.stage.centerX + 150
      buttonInvite.y = FT.stage.bounds.bottom - 130
      buttonInvite.on('pointerup', () => {
        rm.sound($soundButton).play()
        hooks.invite()
      })
      this.addChild(buttonInvite)

      await timer.delay(400)
      this.showBubbleForOldUser()
    }
  }

  showBubbleForOldUser() {
    const textureName =
      store.temp >= 40
        ? 'bed-bubble-friend-enough'
        : 'bed-bubble-friend-not-enough'
    const bubble = new Sprite(rm.texture(textureName))
    bubble.anchor.set(0, 1)
    bubble.scale.set(0.8)
    bubble.x = 170
    bubble.y = 530
    rm.sound($soundBubble).play()

    this.addChild(bubble)
  }

  initFriend = () => {
    const { rm } = FT

    this.addSubtitlePlayer()

    const buttonJoin = new Sprite(rm.texture($buttonJoin))
    buttonJoin.interactive = true
    buttonJoin.anchor.set(0.5)
    buttonJoin.x = FT.stage.centerX - 150
    buttonJoin.y = FT.stage.bounds.bottom - 130
    buttonJoin.on('pointerup', () => {
      rm.sound($soundButton).play()
      hooks.join()
    })
    this.addChild(buttonJoin)

    const buttonCreate = new Sprite(rm.texture($buttonCreate))
    buttonCreate.interactive = true
    buttonCreate.anchor.set(0.5)
    buttonCreate.x = FT.stage.centerX + 150
    buttonCreate.y = FT.stage.bounds.bottom - 130
    buttonCreate.on('pointerup', () => {
      rm.sound($soundButton).play()
      store.reset()
      this.gotoIntroScene()
      hooks.onRecreate()
    })
    this.addChild(buttonCreate)
  }

  showShareTip = () => {
    const mask = new Mask()
    mask.interactive = true

    const tip = new Sprite(rm.texture($shareTip))
    const offset = 50
    tip.anchor.set(1, 0)
    tip.position.set(
      FT.stage.bounds.right - offset,
      FT.stage.bounds.top + offset
    )
    mask.addChild(tip)

    mask.on('pointerup', event => {
      mask.parent.removeChild(mask)
      event.stopPropagation()
    })

    this.addChild(mask)
  }

  gotoIntroScene = () => {
    FT.sm.load('intro', { transition: true })
  }
}

export default Bed
